import { useSelector } from "react-redux";

const Currency = (props) => {
    const {user} = useSelector(state => state.login);

  return  Intl.NumberFormat('en-US', { style: 'currency', currency: user?.country === "United States" ? 'USD' : 'INR' }).format(props.value)
};

export default Currency;
